"use client"

import React, { useEffect } from "react"
import { Route, useHistory } from "react-router-dom"

import Login from "./Pages/Login"

import Sidebar from "./Components/Sidebar"
import Header from "./Components/Header.jsx"
import ProtectedRoute from "./ProtectedRoute"

import useGeneralStore from "../store/generalStore"
import useAuthStore from "../store/authStore.js"
import LitigationBatch from "./Pages/Litigation/LitigationBatch.jsx"
import CaseListingPage from "./Pages/Litigation/CaseListingPage.jsx"
import CaseCreation from "./Pages/Litigation/CreateCase.jsx"
import LitigationClient from "./Pages/Litigation/LitigationClient.jsx"
import ManageInvoice from "./Pages/Invoice/ManageInvoice.jsx"
import ManageAssignments from "./Pages/Assignments/ManageAssignments.jsx"


const LitigationRoutes = () => {
    const isSidebarOpen = useGeneralStore((state) => state.is_sidebar_open)
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
    const userData = useAuthStore((state) => state.userData)
    const history = useHistory()

    useEffect(() => {
        if (isAuthenticated && userData) {
            const userGroups = userData?.groups || []
            if (userGroups.includes("admin")) {
                if (history.location.pathname === "/admin/login") {
                    history.push("/admin/litigation/batch")
                }
            }
        }
        else {
            history.push("/admin/login")
        }
    }, [isAuthenticated, userData, history])

    return (
        <>
            <Route exact path="/admin/login" component={Login} />

            {isAuthenticated && (
                <>
                    <aside className={`${isSidebarOpen ? "sidebar" : "sidebar sidebar-hide"}`}>
                        <Sidebar />
                    </aside>

                    <section className={`${isSidebarOpen ? "content" : "content content-full"}`}>
                        <Header />
                        <div className="content-part">
                            <ProtectedRoute exact path="/admin/litigation/batch" component={LitigationBatch} />
                            <ProtectedRoute exact path="/admin/litigation/client" component={LitigationClient} /> 
                            
                            <ProtectedRoute exact path="/admin/litigation/cases" component={CaseListingPage} />
                            <ProtectedRoute exact path="/admin/litigation/cases/:batchId" component={CaseListingPage} />
                            <ProtectedRoute exact path="/admin/litigation/create-case" component={CaseCreation} />
                            
                            <ProtectedRoute exact path="/admin/invoice/manage" component={ManageInvoice} />
                            <ProtectedRoute exact path="/admin/assignments/manage" component={ManageAssignments} />
                        </div>
                    </section>
                </>
            )}
        </>
    )
}

export default React.memo(LitigationRoutes)
